//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["groupOperator"],
  methods: {
    updateValue: function (event) {
      this.groupOperator.updateCurrentOperator(event);
    }
  }
};
